import { Workflow } from '@/models/workflow/workflow'
import { WorkflowType } from '@/types/workflow'
import type { WorkflowInstanceDto } from '@/api/origin-workflow-svc'

export class EcrWorkflow extends Workflow {
  constructor(data: WorkflowInstanceDto) {
    super(data, WorkflowType.ECR_VLEI_PREREQ)
  }
}
